import React, { useState, useEffect } from 'react'
import { connect } from "react-redux";
import Dashboard from '../components/Menu/Dashboard';
import LoadingScreen from '../components/Complements/LoadingScreen';
import UserPanelInfoMobile from '../components/Complements/UserPanelInfoMobile';
import DialogOTP from '../components/Complements/DialogOTP';
import UserPanelInfo from '../components/Complements/UserPanelInfo';
import MessageInfo from '../components/Complements/MessageInfo';
import { Grid} from '@material-ui/core';
import { validateIp } from '../functions/store';
import { osName, osVersion, isMobile } from 'react-device-detect';
import { filterArrayEqual, isEmpty } from '../functions/arrays';
import TranviaQR from '../components/Tranvia/TranviaQR';
import { feathersCreateData } from "../services"
import { createProcessMeterCode } from './../actions/metersCore'
import { sendEmailWithVoucher } from "./../actions/sendEmailWithVoucher";
import { sendLogs } from '../functions/function-logs';
import { getBalanceUser } from "./../actions/balances";
import { encrypt, sendMobile } from '../functions/mobile';
import { history } from '../helpers/history';
import { urlVoucher } from '../services/urls';
import moment from 'moment'
import TranviaFormReduxForm from '../components/Tranvia/TranviaForm';
import PaymentConfirmationDialog from '../components/Payments/PaymentConfirmationDialog';

const TranviaContainer = props => {
    const {
        user,
        auth,
        balances,
        agreementsSwitchServices,
        handleOpenSnack,
        getDeviceData,
        devices,
        updateIpDevice,
        sendEmailWithVoucher,
        type,
        quotas,
        getParametersTranviaServices,

    } = props
    const [accountSelected, setAccountSelected] = useState(balances[0])
    const [objectSelectedAll, setObjectSelectedAll] = useState({
        agreementSelected: {
            AgreementForm: [],
            category: "",
            hasIndividualRate: 1,
            hasBilling: 1,
            name: "",
            rate: "0",
            uuid: "",
            identity: "",
            nameIdentity: ""
        },
        referenceFavoriteSelected: {},
        responseTransaction: {},
        responseConsultDebt: {
            uuidConsultDebt: "",
            customer: "",
            identification: "",
            agreement: "",
            reference: "",
            headings: []
        },
        rateAgreementsCoreSelected: {
            Secuencial: 0,
            Nombre: "",
            Comision: 0
        },
        payment: {
            concept: ""
        },
        customAmount: 0
    })


    const [OTP, setOTP] = useState({
        id: '',
        openOtp: false,
        type: '',
        code: ''
    })
    const [openDialogOTP, setOpenDialogOTP] = useState(false)
    // Rederer
    const [showVoucher, setShowVoucher] = useState(false)
    //Loading
    const [loading, setLoading] = useState(false)
    //ticket purchase date
    const [dateStart, setDateStart] = useState(new Date())
    const [customAmountCount, setCustomAmountCount] = useState(0)
    const [parametersTranviaServices, setParametersTranviaServices] = useState({})
    const [ticket, setTicket] = useState([])
    const [rate, setRate] = useState(0.00)
    const [responseTranvia, setResponseTranvia] = useState('')
    const [dataTranvia, setDataTranvia] = useState({})
    const [dialogDataTranvia, setDialogDataTranvia] = useState([])
    const [openDialogTranvia, setOpenDialogTranvia] = useState(false)
    const [onReset, setOnReset] = useState(false)
    const handleDateStart = (date) => {
        setDateStart(date)
    }
    const handleParameterRateCount = (data) => {
        setTicket(data.tarifas)
        setRate(data.total)
        setDataTranvia(data)
    }
    const mount = () => {
        const unmount = () => {
            setLoading(true)
            getParametersTranviaServices().then(
                res => {
                    if (res.payload.data !== undefined) {
                        if (res.payload.data.length !== 0) {
                            res.payload.data.tarifas.map((data, i) => {
                                data.tar_cant = 0
                                return null
                            })
                            res.payload.data.cant = 0
                            setParametersTranviaServices(res.payload.data)
                            setLoading(false)
                        } else if (res.payload.error) {
                            setLoading(false)
                            setParametersTranviaServices({message: res.payload.message, error: res.payload.error})
                            handleOpenSnack(res.payload.message, "error")
                        }
                    } else {
                        setLoading(false)
                        setParametersTranviaServices({message: 'Ha ocurrido un error en el servicio de tranvia.', error: true})
                        handleOpenSnack("Los servicios están temporalmente fuera de servicio. Por favor intente mas tarde", "error")
                    }
                }
            )
            updateBalances()
            setShowVoucher(false)
        }
        return unmount()
    }
    useEffect(mount, [type])

    // PETICIONES AL SERVIDOR
    const handleAccountSelect = (value) => {
        setAccountSelected(value.props.value)
    }
    const updateBalances = async () => {

        setLoading(true)
        await props.getBalanceUser({ NumeroCliente: user.NumeroCliente, SecuencialEmpresa: 1, EstaActiva: true }).then(res => {
            console.log(res, "ressss")
            const { data } = res.payload;
            const getdataaccountselected = data.cuentaDetallesConsolidado.filter(item => {
                return (item.numeroCuenta === accountSelected.numeroCuenta) ? true : false;

            })
            setAccountSelected(getdataaccountselected[0])
        })
            .catch(err => err)
        setLoading(false)
    }
    const handleValidateAttemptsOtp = async () => {
        try {
            let ticket_ = []
            ticket.map(row => {
                ticket_.push({
                    tipo: row.tar_id,
                    cantidad: row.tar_cant,
                    tar_descripcion: row.tar_descripcion,
                    tar_valor: row.tar_valor
                })
                return null
            })
            let usuario = {
                tipo_identificacion: user.DocumentType === '3' ? 'cedula' :
                    user.DocumentType === '1' ? 'ruc' : 'pasaporte',
                identificacion: user.DocumentId,
                nombres: user.Name,
                correo: user.Mail,
                telefono: user.CellPhone
            }
            const log = await sendLogs(auth.vusk, {
                type,
                data: {
                    idOtp: OTP.id,
                    data: {
                        access: "PAYMENT",
                        body: {
                            ticket: ticket_,
                            usuario,
                            NumeroCuentaOrigen: accountSelected.numeroCuenta,
                            fecha: moment(new Date(dateStart)).format('YYYY-MM-DD HH:mm'),
                        }
                    }
                }
            }, 44, devices, getDeviceData)
            if (log) {
                setOTP({
                    id: '',
                    openOtp: false,
                    type: '',
                    code: ''
                })
                setOpenDialogOTP(false)
                handleOpenSnack('Se ha excedido el número de intentos permitidos. Por favor contáctese con Cooperativa Erco. ', 'error');
            } else {
                setLoading(false)
            }
        } catch (error) {
            setLoading(false)
            handleOpenSnack('Ha ocurrido un error al validar el código OTP.', 'error');
        }
    }
    const handleOTPSubmit = async ({ data }) => {
        try {
            const { ip, mac, device } = devices
            setLoading(true)
            const sendData = encrypt(JSON.stringify({
                inputOtp: data,
                type: 44,
                ip,
                mac,
                device
            }))
            feathersCreateData('code-validation', { sendData })()
                .then(async res => {
                    if (res.type === 'success') {

                        const { getDeviceData, updateIpDevice } = props
                        let ipSend = await validateIp(ip, getDeviceData, updateIpDevice)
                        let mac = 'NAVEGADOR'
                        let deviceData = `${osName} ${osVersion}`
                        if (!isEmpty(devices)) {
                            const { device, ip: ipDevice, mac: macDevice } = devices
                            deviceData = device;
                            ipSend = ipDevice;
                            mac = macDevice;
                        }
                        let ticket_ = []
                        ticket.map(row => {
                            ticket_.push({
                                tipo: row.tar_id,
                                cantidad: row.tar_cant,
                                tar_descripcion: row.tar_descripcion,
                                tar_valor: row.tar_valor
                            })
                            return null
                        })
                        let usuario = {
                            tipo_identificacion: user.DocumentType === '3' ? 'cedula' :
                                user.DocumentType === '1' ? 'ruc' : 'pasaporte',
                            identificacion: user.DocumentId,
                            nombres: user.Name,
                            correo: user.Mail,
                            telefono: user.CellPhone
                        }
                        let date = moment(new Date(dateStart)).format('YYYY-MM-DD HH:mm')
                        let auxDate = moment(new Date()).add(parametersTranviaServices.lapso_inicio_vigencia, 'minutes').format('YYYY-MM-DD HH:mm')
                        const response_payment = await feathersCreateData("tranvia-services", {
                            access: "PAYMENT",
                            body: {
                                ticket: ticket_,
                                usuario,
                                NumeroCuentaOrigen: accountSelected.numeroCuenta,
                                fecha: date > auxDate ? date : auxDate,
                                otp: data,
                                ip: ipSend,
                                device: deviceData,
                                mac,
                                rate,
                                msg_informative: parametersTranviaServices.msg_informativo
                            }
                        })()
                        console.log(response_payment, "response_payment")
                        const { data: dataTranvia, estado, mensaje } = response_payment;
                        if (estado === true) {
                            setOTP({
                                ...OTP,
                                openOtp: false
                            })
                            setOpenDialogOTP(false)
                            setResponseTranvia(dataTranvia.data)
                            setShowVoucher(true)
                            handleOpenSnack((mensaje) ? mensaje : 'Se ha realizado exitosamente el pago.', 'success')
                            updateBalances()
                        } else {
                            setOTP({
                                ...OTP,
                                openOtp: false
                            })
                            setOpenDialogOTP(false)
                            handleOpenSnack((mensaje) ? mensaje : "Se ha presentado un inconveniente al procesar el pago debido a la falta de conexión con el servicio de tranvía.", "error")
                        }
                        setOpenDialogOTP(false)
                        setLoading(false)
                    } else {
                        handleValidateAttemptsOtp()
                        setLoading(false)
                        handleOpenSnack(res.message, res.type)
                    }
                })
        } catch (error) {
            setLoading(false)
            setOTP({
                ...OTP,
                openOtp: false
            })
            setOpenDialogOTP(false)
            handleOpenSnack("Ha ocurrido un error al realizar el pago.", "error")
        }
    }
    const handleGenerateOtp = async (type) => {
        setLoading(true)
        try {
            const { ip } = devices
            let ipSend = await validateIp(ip, getDeviceData, updateIpDevice)
            let deviceData = `${osName} ${osVersion}`
            let mac = 'NAVEGADOR'
            if (!isEmpty(devices)) {
                const { device, ip: ipDevice, mac: macDevice } = devices
                deviceData = device;
                ipSend = ipDevice;
                mac = macDevice;
            }
            const sendData = encrypt(JSON.stringify({ emited: 'NAVCREATECODE', type, deviceData, ip: ipSend, mac }))
            feathersCreateData('codes-recovery', { sendData })()
                .then((res) => {
                    setOTP({
                        ...OTP,
                        type: "",
                        openOtp: true,
                    })
                    setOpenDialogOTP(true)
                    setLoading(false)

                    setLoading(false)
                }).catch(err => {
                    setLoading(false)
                    handleOpenSnack('No se ha podido realizar la transacción. Por favor intente nuevamente', 'error')
                })
        } catch (error) {
            console.log(error)
            setLoading(false)
            handleOpenSnack('No se ha podido generar el código. Por favor intente nuevamente.', 'error')
        }
    }
    const handleChangeInputOtp = (valueinput) => {
        if (valueinput.toString().length === 6) {
            handleOTPSubmit({ data: valueinput.toString() });
        }
    }
    const handleCancelActionConsultDebt = () => {
        setOnReset(!onReset)
    }
    console.log(dialogDataTranvia, "dialogDataTranvia")

    const handleSubmitPayment = (valueFormConsultDebt) => {
        try {
            //setLoading(true)
            let tempDate = new Date()
            const { daily, monthly, mAmount, dAmount, updateQuota } = quotas[0]
            let sameDay = moment(moment(new Date(updateQuota)).format('YYYY-MM-DD')).isSame(moment(new Date()).format('YYYY-MM-DD'))
            let sameMonth = moment(moment(new Date(updateQuota)).format('YYYY-MM-DD')).isSame(moment(new Date()).format('YYYY-MM-DD'), 'month')
            if (parseFloat(rate) > parseFloat(accountSelected.saldoDisponible)) {
                setLoading(false)
                handleOpenSnack('El saldo es insuficiente para realizar la transacción.', 'error')
            } else if ((parseFloat(dAmount) >= parseFloat(daily) ||
                (parseFloat(dAmount) + parseFloat(rate)) > parseFloat(daily)) && sameDay
            ) {
                this.props.handleOpenSnack('El monto excede el límite de transferencia diaria', 'error')
            } else if ((parseFloat(mAmount) >= parseFloat(monthly) ||
                (parseFloat(mAmount) + parseFloat(rate)) > parseFloat(monthly)) && sameMonth
            ) {
                this.props.handleOpenSnack('El monto excede el límite de transferencia mensual', 'error')
            } else if (parseFloat(rate) > parseFloat(daily)) {
                this.props.handleOpenSnack('El valor excede el monto diario permitido', 'error')
            } else if (parseFloat(rate) > parseFloat(monthly)) {
                this.props.handleOpenSnack('El valor excede el monto mensual permitido', 'error')
            } else {
                let auxDateStart = moment(dateStart).format('YYYY-MM-DD HH:mm')
                let auxTempStart = moment(tempDate).format('YYYY-MM-DD HH:mm')
                if (auxDateStart < auxTempStart) {
                    setLoading(false)
                    handleOpenSnack('La fecha y hora seleccionada no debe ser menor a la actual.', 'error')
                    setDateStart(new Date())
                } else {
                    let array = []
                    console.log(array, "array")
                    dataTranvia.tarifas.map(row => {
                        array.push({
                            index: row.tar_id,
                            label: row.tar_descripcion,
                            value: row.tar_cant,
                        })
                        return null
                    })
                    let date = moment(new Date(dateStart)).format('YYYY-MM-DD HH:mm')
                    let auxDate = moment(new Date()).add(parametersTranviaServices.lapso_inicio_vigencia, 'minutes').format('YYYY-MM-DD HH:mm')
                    array.push({
                        index: array.length + 1,
                        label: 'Total',
                        value: '$' + dataTranvia.total,
                    }, { 
                        index: array.length + 1,
                        label: 'Fecha inicio vigencia',
                        value: date > auxDate ? date : auxDate
                    })
                    setDialogDataTranvia(array)
                    console.log(array, "arayyyyyavgd2")
                    setOpenDialogTranvia(true)
                }
            }
        } catch (error) {
            console.log(error, "erorrrrrr")
            setLoading(false)
            handleOpenSnack('No se ha podido generar el código. Por favor intente nuevamente.', 'error')
        }
    }

    const closeDialogTranvia = () => {
        setOpenDialogTranvia(true)
        setLoading(false)
    }
    const handleAcceptDialogTranvia = async () => {
        setOpenDialogTranvia(true)
        setLoading(false)
        await props.getQuotas({ cedule: props.auth.vusk })
        handleGenerateOtp(44)
    }
    
    //VOUCHER
    const handleSendEmailWithVoucher = () => {
        setLoading(true)
        const { correoElectronico } = user;
        const { DocumentoTransaccion } = objectSelectedAll.responseTransaction;
        let object_send_email_with_voucher = {
            Documento: "voucher_" + DocumentoTransaccion,
            Email: correoElectronico,
            name: accountSelected.codigo,
            name_voucher: objectSelectedAll.responseTransaction.name_voucher
        }
        sendEmailWithVoucher(object_send_email_with_voucher).then(
            response => {
                const { message, type } = response.payload;
                setLoading(false)
                handleOpenSnack(message, type);
            }
        ).catch(
            error => {
                setLoading(false)
                handleOpenSnack('No se ha enviado correctamente el comprobante. Por favor vuelva a intentar.', 'error')
            }
        )
    }
    const handleCancelTransferForm = () => {
        history.push('/')
    }
    const onCancelAction = () => {
        setShowVoucher(false)
    }
    const handleDownloadVoucher = () => {
        window.open(urlVoucher + responseTranvia.NombreArchivoComprobante + ".pdf", '_blank');
    }
    const handleSetNewPayment = () => {
        setShowVoucher(false)
        setObjectSelectedAll({
            ...objectSelectedAll,
            responseTransaction: {}
        })
    }
    const onKeyPress = (ev) => {
        if (ev.key === 'Enter') {
            ev.preventDefault()
        } else {
            if (ev.target.value.toString().length === 6) {
                handleOTPSubmit({ data: ev.target.value });
            }
        }
    }
    const receivePrompt = (description) => {
        const { otp, request } = this.state
        const { cedule } = props.devices
        return this.props.refusePayment(otp, request, cedule, description).then(r => {
        })
    }
    const getNumberOfTickets = (ticketObj) => {
        let totalCantidad = 0;
        for (let i = 0; i < ticketObj.ticket.length; i++) {
            totalCantidad += ticketObj.ticket[i].cantidad;
        }
        return totalCantidad
    }
    //Renderizar Vistas
    const renderProcess = () => {
        return (<TranviaFormReduxForm
            onSubmit={handleSubmitPayment}
            agreements={agreementsSwitchServices}
            onCancelAction={handleCancelActionConsultDebt}
            handleDateStart={handleDateStart}
            dateStart={dateStart}
            handleParameterRateCount={handleParameterRateCount}
            customAmountCount={customAmountCount}
            setCustomAmountCount={setCustomAmountCount}
            parametersTranviaServices={parametersTranviaServices}
            onReset={onReset}
        />)
    }
    const renderQR = () => {
        return <TranviaQR
            amount={responseTranvia.ticket.total}
            titleheader={"PAGO EXITOSO"}
            title={"Ticket Virtual Tranvia"}
            titleone={"Validez"}
            viewVoucher={false}
            typesizegrid={6}
            mac={devices.mac}
            msg_informative={parametersTranviaServices.msg_informativo}
            nombreCliente={(user.esPersonaNatural === false) ? user.razonSocial : user.nombres + " " + user.apellidos}
            ticketNumber={responseTranvia.Id_transaccion_municipio_ticket}
            tarifas={ticket}
            titlebuttonnew={"Nuevo Ticket"}
            titletwo={'Información del ticket'}
            numberOfTickets={getNumberOfTickets(responseTranvia.ticket)}
            databodyone={[
                {
                    title: "Desde",
                    value: responseTranvia.fecha_hora_inicio_vigencia,
                    order: 1
                },
                {
                    title: "Hasta",
                    value: responseTranvia.fecha_hora_fin_vigencia,
                    order: 2
                },
            ]}
            responseTranvia={responseTranvia}
            textButtonCancel={"Nuevo Ticket"}
            handleSendEmailWithVoucher={handleSendEmailWithVoucher}
            handleCancel={handleCancelTransferForm}
            onActionAfter={handleSetNewPayment}
            handleDownloadVoucher={handleDownloadVoucher}
            handleResetPayment={onCancelAction}
            handleDownloadDevice={() => {
                try {
                    const namefile = responseTranvia.NombreArchivoComprobante
                    let send = {
                        type: 'action',
                        action: 'export_voucher',
                        data: urlVoucher + namefile + ".pdf",
                        nameFile: namefile,
                        extension: 'pdf',
                        messageSend: 'Ticket Tranvia'
                    }
                    sendMobile(JSON.stringify(send))
                } catch (error) {
                    console.log(error, "error")
                }
            }}
        />
    }
    const renderBody = () => {
        if (isMobile) {
            if (isEmpty(accountSelected)) {
                return <MessageInfo type='error' text={'No dispone de una cuenta para el pago de este servicio.'} />
            } else {
                return <UserPanelInfoMobile
                    tittle={'Tickets de Tranvía'}
                    user={user}
                    balances={balances}
                    accountSelected={accountSelected}
                    changeAccount={handleAccountSelect}
                >
                    {(showVoucher === false) ? renderProcess() : renderQR()}
                </UserPanelInfoMobile>
            }

        } else {
            if (isEmpty(accountSelected)) {
                return <MessageInfo type='error' text={'No dispone de una cuenta para el pago de este servicio.'} />
            } else {
                return <Grid container spacing={3}>
                    <Grid item xs={12} md={6} lg={6} xl={6}>
                        <UserPanelInfo
                            tittle={'Tickets de Tranvía'}
                            user={user}
                            balances={balances}
                            accountSelected={accountSelected}
                            changeAccount={handleAccountSelect}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} lg={6} xl={6}>
                        {(showVoucher === false) ? renderProcess() : renderQR()}
                    </Grid>
                </Grid>
            }
        }
    }
    const timeLifeTokenObj = filterArrayEqual(props.parameters, 'code', 'TIME_LIFE_TOKEN')
    const timeLifeToken = parseInt(timeLifeTokenObj[0].value)
    return (
        <div>
            <Dashboard
                title="Dashboard"
                body={renderBody()}
                multiple={false}
            />
            <PaymentConfirmationDialog
                titleDialog={'¿Esta seguro que desea realizar la siguiente compra?'}
                openDialog={openDialogTranvia}
                onCloseDialogPaymentConfirmation={closeDialogTranvia}
                dataTransaction={dialogDataTranvia}
                onHandleAcceptTransaction={handleAcceptDialogTranvia}
            />
            <DialogOTP
                openDialogOTP={openDialogOTP}
                onCloseDialogOTP={() => setOpenDialogOTP(false)}
                initialTime={Date.now()}
                loading={loading}
                showQR={false}
                OTPSubmit={handleOTPSubmit}
                handleChangeInputOtp={handleChangeInputOtp}
                onKeyPress={onKeyPress}
                timeLifeToken={timeLifeToken}
                refreshToken={receivePrompt}
            />
            <LoadingScreen open={loading} />
        </div>
    )
}
export default connect(null, {
    createProcessMeterCode,
    sendEmailWithVoucher,
    getBalanceUser,
})(TranviaContainer)
